import React from 'react';

// 이 파일은 git에 커밋되지 않는 로컬 라우트 정의용 파일입니다.
// 필요한 테스트 페이지나 라우트가 있다면 이곳에 등록하세요.
// 이 파일이 없으면 빌드시 DevRoutes.stub.tsx가 사용됩니다. (vite.config.ts 참조)

// test ui component imports from ignored 'ui/test' folder
const UIComponentsPage = React.lazy(() => import('@/ui/test/UIComponentsPage'));
const ChatDesignConcept = React.lazy(() => import('@/ui/test/ChatDesignConcept'));
const ChatDesignFigma = React.lazy(() => import('@/ui/test/ChatDesignFigma'));
const Chat = React.lazy(() => import('@/ui/test/Chat'));

const DevRoutes = [
    { path: "/test/ui", element: <UIComponentsPage /> },
    { path: "/test/design-lab", element: <ChatDesignConcept /> },
    { path: "/test/design-figma", element: <ChatDesignFigma /> },
    { path: "/test/chat", element: <Chat /> },
];

export default DevRoutes;
